import {
  Grid,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Typography,
} from "@material-ui/core";
import SanitizedGrid from "components/SanitizedGrid";
import moment from "moment";
import { FormDataConsumer } from "react-admin";
import { sumCentsAmountToDolar } from "utils/tools";
import CalculationButton from "./CalculationButton";
import { makeStyles } from "@material-ui/core";
import { useFormState } from "react-final-form";

interface IStudentCreateCostCalculationProps {
  isLoaded: boolean;
  setIsLoaded: (value: boolean) => void;
  resultCalculations: IRegularAndCcaCalculationResults | null;
  format: string;
  isCalculationCostCreateStudentInvalid: any;
  setResultCalculations: (
    value: IRegularAndCcaCalculationResults | null,
  ) => void;
  setIsCalculationButtonClicked: (value: boolean) => void;
  selectedSchool: ISchool | null;
}

const useStyles = makeStyles({
  table: {
    marginTop: "10px",
    minWidth: 650,
    padding: "1rem",
  },
  subTotal: {
    fontWeight: 600,
    fontSize: "0.875rem",
  },
  grandTotal: {
    fontWeight: 700,
  },
});

export const StudentCreateCostCalculation = ({
  isLoaded,
  setIsLoaded,
  resultCalculations,
  format,
  isCalculationCostCreateStudentInvalid,
  setResultCalculations,
  setIsCalculationButtonClicked,
  selectedSchool,
}: IStudentCreateCostCalculationProps) => {
  const classes = useStyles();
  const { values } = useFormState();

  return (
    <>
      <FormDataConsumer>
        {({ formData, ...rest }) =>
          formData.isNotTakeSchedule === false &&
          (formData.scheduleType === "regular" ||
            formData.scheduleType === "cca" ||
            formData.scheduleType === "both") && (
            <>
              <Grid item={true} xs={12}>
                {isLoaded && (
                  <SanitizedGrid container spacing={2}>
                    {resultCalculations.hasOwnProperty(
                      "updateRegularScheduleResponse",
                    ) &&
                      resultCalculations.updateCcaScheduleResponse !== null &&
                      resultCalculations.updateRegularScheduleResponse.length >
                        0 && (
                        <>
                          {resultCalculations.updateRegularScheduleResponse.map(
                            (resultCalculation: IRegularCalculationResult) => (
                              <Grid
                                item={true}
                                xs={12}
                                key={`rate-regular-${resultCalculation.rateChart.id}`}
                              >
                                <Typography variant="h6">
                                  Regular Cost Preview for Rate Chart #
                                  {resultCalculation.rateChart.id} -{" "}
                                  {resultCalculation.rateChart.name}
                                </Typography>
                                <TableContainer>
                                  <Table className={classes.table} size="small">
                                    <TableHead>
                                      <TableRow>
                                        <TableCell>Schedule Date</TableCell>
                                        <TableCell>Amount</TableCell>
                                      </TableRow>
                                    </TableHead>
                                    <TableBody>
                                      {resultCalculation.transactions
                                        .filter(
                                          (item: IResultCalculationItem) =>
                                            item.type === "charge" ||
                                            item.type === "refund",
                                        )
                                        .map(
                                          (item: IResultCalculationItem, i) => {
                                            return (
                                              <TableRow key={i}>
                                                <TableCell>
                                                  {moment
                                                    .utc(item.fromDate)
                                                    .format(format)}{" "}
                                                  -{" "}
                                                  {moment
                                                    .utc(item.toDate)
                                                    .format(format)}
                                                </TableCell>
                                                <TableCell>
                                                  ${" "}
                                                  {(item.total / 100).toFixed(
                                                    2,
                                                  )}
                                                </TableCell>
                                              </TableRow>
                                            );
                                          },
                                        )}

                                      {values.isApplyStudentSubsidy && (
                                        <>
                                          {/* Sub Total (charge + refund) */}
                                          <TableRow>
                                            <TableCell>Sub Total :</TableCell>
                                            <TableCell>
                                              ${" "}
                                              {sumCentsAmountToDolar(
                                                resultCalculation.transactions.filter(
                                                  (item) =>
                                                    item.type === "charge" ||
                                                    item.type === "refund",
                                                ),
                                              )}
                                            </TableCell>
                                          </TableRow>
                                          {/* Subsidy or Subsidy Refund */}
                                          {resultCalculation.transactions.some((item) => item.type === "subsidy") ? (
                                            <TableRow>
                                              <TableCell>Subsidy :</TableCell>
                                              <TableCell>
                                                ${" "}
                                                {sumCentsAmountToDolar(
                                                  resultCalculation.transactions.filter(
                                                    (item) => item.type === "subsidy"
                                                  )
                                                )}
                                              </TableCell>
                                            </TableRow>
                                          ) : resultCalculation.transactions.some((item) => item.type === "subsidy_refund") ? (
                                            <TableRow>
                                              <TableCell>Subsidy Refund :</TableCell>
                                              <TableCell>
                                                ${" "}
                                                {sumCentsAmountToDolar(
                                                  resultCalculation.transactions.filter(
                                                    (item) => item.type === "subsidy_refund"
                                                  )
                                                )}
                                              </TableCell>
                                            </TableRow>
                                          ) : null}
                                        </>
                                      )}

                                      {/* Grand Total */}
                                      <TableRow>
                                        <TableCell>Total :</TableCell>
                                        <TableCell>
                                          ${" "}
                                          {sumCentsAmountToDolar(
                                            resultCalculation.transactions,
                                          )}
                                        </TableCell>
                                      </TableRow>
                                    </TableBody>
                                  </Table>
                                </TableContainer>
                              </Grid>
                            ),
                          )}
                        </>
                      )}

                    {resultCalculations.hasOwnProperty(
                      "updateCcaScheduleResponse",
                    ) &&
                      resultCalculations.updateCcaScheduleResponse !== null &&
                      resultCalculations.updateCcaScheduleResponse.length >
                        0 && (
                        <>
                          {resultCalculations.updateCcaScheduleResponse.map(
                            (resultCalculation: ICcaCalculationResult) => (
                              <Grid
                                item={true}
                                xs={12}
                                key={`rate-cca-${resultCalculation.ccaRateChart.id}`}
                              >
                                <Typography variant="h6">
                                  CCA Cost Preview for Rate Chart #
                                  {resultCalculation.ccaRateChart.id} -{" "}
                                  {resultCalculation.ccaRateChart.name}
                                </Typography>
                                <TableContainer>
                                  <Table className={classes.table} size="small">
                                    <TableHead>
                                      <TableRow>
                                        <TableCell>Schedule Date</TableCell>
                                        <TableCell>Amount</TableCell>
                                      </TableRow>
                                    </TableHead>
                                    <TableBody>
                                      {resultCalculation.transactions.map(
                                        (item: IResultCalculationItem, i) => {
                                          return (
                                            <TableRow key={i}>
                                              <TableCell>
                                                {moment
                                                  .utc(item.fromDate)
                                                  .format(format)}{" "}
                                                -{" "}
                                                {moment
                                                  .utc(item.toDate)
                                                  .format(format)}
                                              </TableCell>
                                              <TableCell>
                                                ${" "}
                                                {(item.total / 100).toFixed(2)}
                                              </TableCell>
                                            </TableRow>
                                          );
                                        },
                                      )}

                                      <TableRow>
                                        <TableCell>Total :</TableCell>
                                        <TableCell>
                                          ${" "}
                                          {sumCentsAmountToDolar(
                                            resultCalculation.transactions,
                                          )}
                                        </TableCell>
                                      </TableRow>
                                    </TableBody>
                                  </Table>
                                </TableContainer>
                              </Grid>
                            ),
                          )}
                        </>
                      )}

                    {resultCalculations.hasOwnProperty(
                      "updateCcaScheduleResponse",
                    ) &&
                      resultCalculations.updateCcaScheduleResponse !== null &&
                      resultCalculations.updateCcaScheduleResponse.length ===
                        0 &&
                      resultCalculations.hasOwnProperty(
                        "updateRegularScheduleResponse",
                      ) &&
                      resultCalculations.updateCcaScheduleResponse !== null &&
                      resultCalculations.updateRegularScheduleResponse
                        .length === 0 && (
                        <Grid item={true} xs={12}>
                          <Typography variant="h6">
                            No Change in Cost.
                          </Typography>
                        </Grid>
                      )}
                  </SanitizedGrid>
                )}
              </Grid>

              <Grid item={true} xs={12}>
                <FormDataConsumer>
                  {({ formData }) => {
                    formData.allowSelectWave =
                      selectedSchool?.isAllowParentSelectWave;
                    return (
                      <div>
                        <CalculationButton
                          invalid={isCalculationCostCreateStudentInvalid(
                            formData,
                            selectedSchool,
                          )}
                          setResultCalculations={setResultCalculations}
                          setIsLoaded={setIsLoaded}
                          setIsCalculationButtonClicked={
                            setIsCalculationButtonClicked
                          }
                          formData={formData}
                        />
                      </div>
                    );
                  }}
                </FormDataConsumer>
              </Grid>
            </>
          )
        }
      </FormDataConsumer>
    </>
  );
};
